import { ComboBox } from '@interstate/components/ComboBox';
import { ListBulletIcon } from '@interstate/components/Icons/ListBulletIcon';
import { Typography } from '@interstate/components/Typography';
import type { CSSProperties } from 'react';
import MileageCostOptionsSlideOut from '../../mileageCostOptions/MileageCostOptionsSlideOut.interstate';
import { OptionsButton } from './CustomMileageField.style';
import rem from 'polished/lib/helpers/rem';
import { useCustomMileageField } from './hooks/useCustomMileageField';

export { getMatchedValue, getMessageMileage } from './hooks/useCustomMileageField';

const dealerDiscountContainerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: '17px',
    justifyContent: 'space-between',
    marginBottom: rem(6)
};

// Scope select-on-focus to the combo only.
const comboBoxContainerStyle: CSSProperties = { display: 'contents' } satisfies CSSProperties;

const CustomMileageField = () => {
    const {
        label,
        isLocked,
        hasOptions: enableLeaseContractField,
        isSlideOutOpen: slideOut,
        toggleSlideOut,
        onKeyDown: handleKeyDown,
        onComboBoxFocus: handleComboBoxFocus,
        comboBoxProps
    } = useCustomMileageField();

    return (
        <div onKeyDown={handleKeyDown}>
            {enableLeaseContractField && (
                <div
                    style={dealerDiscountContainerStyle}
                    data-testid="custom-mileage-label"
                    className="base-deal-activity-control-custom-label"
                >
                    <Typography variant={'body-xs'} color="#6d6d6d" sx={{ cursor: 'default', userSelect: 'none' }}>
                        {label}
                    </Typography>
                    <OptionsButton
                        onClick={toggleSlideOut}
                        component={'button'}
                        data-testid="custom-mileage-options-button"
                        {...(isLocked && { disabled: true, className: 'disabled-button' })}
                    >
                        <ListBulletIcon aria-label="Dealer Discount" />
                        <Typography variant={'body-xs'}>Options</Typography>
                    </OptionsButton>
                </div>
            )}
            <div style={comboBoxContainerStyle} onFocus={handleComboBoxFocus}>
                <ComboBox
                    {...comboBoxProps}
                    displayLabel={!enableLeaseContractField}
                    label={!enableLeaseContractField ? label : undefined}
                />
            </div>
            {slideOut && <MileageCostOptionsSlideOut show={slideOut} onHide={toggleSlideOut} />}
        </div>
    );
};

export default CustomMileageField;
